const DISMISSED_KEY = 'jc-srp-alert-cta-dismissed-session';

/** Whether the SRP "get alerted" CTA should show — hidden for the rest of the session once dismissed. */
export function shouldShowSrpAlertCta(): boolean {
  if (typeof sessionStorage === 'undefined') {
    return true;
  }
  return sessionStorage.getItem(DISMISSED_KEY) !== '1';
}

/** Call when the user dismisses the SRP alert CTA without acting on it (snooze for this session). */
export function markSrpAlertCtaDismissedThisSession(): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  sessionStorage.setItem(DISMISSED_KEY, '1');
}
